module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex collect"
  }, [_c('m-header', {
    attrs: {
      "title": "我的收藏"
    }
  }), _vm._v(" "), _c('view-box', {
    staticClass: "collectBox",
    attrs: {
      "body-padding-bottom": "0"
    }
  }, [_vm._l((_vm.favoritesList), function(item, index) {
    return _c('router-link', {
      key: index,
      staticClass: "list  tab-swiper vux-center",
      attrs: {
        "tag": "div",
        "to": {
          name: 'detail',
          params: {
            id: item.product._id
          }
        }
      }
    }, [_c('div', {
      staticClass: "box1 flex vux-1px-b"
    }, [_c('div', {
      staticClass: "img"
    }, [_c('img', {
      attrs: {
        "src": _vm.UPLOAD_DOMAIN + item.product.thumbnail + '?x-oss-process=image/resize,w_120',
        "default-src": "static/placeholder.png",
        "container": ".collectBox"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "flex-1 text-l"
    }, [_c('span', [_vm._v(_vm._s(item.product.title)), (item.product.specLabel) ? _c('span', [_vm._v("(" + _vm._s(item.product.specLabel) + ")")]) : _vm._e(), (item.product.areaLimit) ? _c('span', [_vm._v("(限售湖北)")]) : _vm._e()]), _vm._v(" "), _c('p', [_c('b', [_vm._v("￥" + _vm._s(_vm._f("fen2yuan")(item.product.price)))])])]), _vm._v(" "), _c('div', {
      staticClass: "collect-tap",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.deleteFavorite(item, index)
        }
      }
    }, [_c('i', {
      staticClass: "iconfont icon-shoucang"
    })])])])
  }), _vm._v(" "), (_vm.favoritesList.length == 0) ? _c('not-data', {
    attrs: {
      "imgPic": "collect"
    }
  }) : _vm._e()], 2), _vm._v(" "), _c('confirm', {
    attrs: {
      "confirm-text": "确定",
      "cancel-text": "取消"
    },
    on: {
      "on-confirm": _vm.confirm
    },
    model: {
      value: (_vm.show1),
      callback: function($$v) {
        _vm.show1 = $$v
      },
      expression: "show1"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("是否切换店铺?")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2a5ef50f"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserCenter/collectList/collectList.vue
// module id = 534
// module chunks = 0